<template>
  <div>
    <div v-if="$store.state.pageLoaded">
      <h1 class="md-headline theatre-title theatre-play-title" v-if="$store.state.selectedObject !== null">
        {{ $store.state.selectedObject.play_title }} -
        <span>
          {{ $store.state.selectedObject.performance_date }} -
          {{ $store.state.selectedObject.performance_time }}
        </span>
      </h1>
      <div class="theatre-container theatre-container-admin">
        <md-button class="md-icon-button md-raised md-accent back-button" title="Natrag" v-on:click="backClicked()">
          <md-icon>keyboard_arrow_left</md-icon>
        </md-button>
        <AdminTheatre/>
        <div class="filter-wrapper">
          <md-field>
            <label>Odaberite ekran</label>
            <md-select v-model="screen">
              <md-option v-for="screen in screens" :value="screen.id"> {{ screen.screen }} </md-option>
            </md-select>
          </md-field>
          <md-button v-if="screen" class="md-raised md-dense md-primary" v-on:click="sendScreen()">Prikaži</md-button>
        </div>
        <div v-if="getSelectedSeats.length > 0 || $store.state.theatre.pricelist_data.category.hasOwnProperty('0')" class="selected-tickets selected-seats">
          <md-card>
            <SelectedSeats :discount="discount" class="md-scrollbar half-height"/>
            <md-card-content class="md-scrollbar half-height">
              <div v-if="$store.state.currentTab.tab == 'ticketTheatre' || fromPage">
                <md-field>
                  <label>Označi kao</label>
                  <md-select v-model="seatCategory">
                    <md-option value="sale">Slobodna prodaja</md-option>
                    <md-option value="reservation">Slobodna prodaja - Rezervacija</md-option>
                    <md-option value="gratis" v-if="showGratis">Gratis</md-option>
                    <md-option value="employee" v-if="showEmployee">Zaposlenik</md-option>
                    <md-option value="theatre_manager">Intendantica</md-option>
                    <md-option value="used_in_performance">Korišteno u predstavi</md-option>
                    <md-option value="sponsor">Sponzorsko</md-option>
                    <md-option value="lease">Zakup</md-option>
                    <md-option value="partner_checkout">Ponuda</md-option>
                    <md-option value="in_guests">U gostima</md-option>
                  </md-select>
                </md-field>
                <div v-if="seatCategory == 'sponsor'">
                  <div>
                    <Autocomplete v-model="partnerID" :getValue="partnerTitle" :stateObject="'sponsors'" :returnField="'id'" :searchBy="'title'" :label="'Odaberi sponzora'"/>
                  </div>
                </div>
                <div v-if="seatCategory == 'lease'">
                  <div>
                    <Autocomplete v-model="partnerID" :getValue="partnerTitle" :stateObject="'leases'" :returnField="'id'" :searchBy="'title'" :label="'Odaberi zakup'"/>
                  </div>
                </div>
                <div v-if="seatCategory == 'partner_checkout'">
                  <div>
                    <Autocomplete v-model="partnerID" :getValue="partnerTitle" :stateObject="'partners'" :returnField="'id'" :searchBy="'title'" :label="'Odaberi partnera'"/>
                  </div>
                  <md-datepicker v-model="expiry" md-immediately>
                    <label>Vrijedi do</label>
                  </md-datepicker>
                </div>
                <md-field v-if="['reservation', 'sale', 'partner_checkout', 'sponsor', 'lease'].includes(seatCategory)">
                  <label>Odaberi popust</label>
                  <md-select v-model="pricelistID">
                    <md-option v-for="price, id in $store.state.selectedObject.pricelist_data.category[1]" :value="id" v-if="discountVisible(id)">{{ getTitle('discounts', 'description', id) }}</md-option>
                  </md-select>
                </md-field>
                <div v-if="seatCategory == 'employee'">
                  <Autocomplete v-model="employeeID" :stateObject="'employees'" :returnField="'id'" :searchBy="'full_name'" :label="'Odaberi zaposlenika'"/>
                </div>
                <md-field>
                  <label>Napomena</label>
                  <md-input v-model="note"/>
                </md-field>
                <md-field v-if="$store.state.theatre.pricelist_data.category.hasOwnProperty('0') && parseInt(getProsceniumAmount) > 0">
                  <label>Proscenij - {{ getProsceniumAmount }}/{{ $store.state.selectedObject.total_extra_seats }}</label>
                  <md-input v-model="proscenium"/>
                </md-field>
              </div>
              <div v-else-if="$store.state.currentTab.tab == 'editTransaction'">
                 <div v-if="$store.state.currentTransaction.data.hasOwnProperty('employee')">
                  <Autocomplete v-model="employeeID" :stateObject="'employees'" :returnField="'id'" :searchBy="'full_name'" :label="'Odaberi zaposlenika'"/>
                </div>
                <md-field v-if="['reservation', 'sale', 'partner_checkout', 'sponsor'].includes($store.state.currentTransaction.status)">
                  <label>Odaberi popust</label>
                  <md-select v-model="pricelistID">
                    <md-option v-for="price, id in $store.state.selectedObject.pricelist_data.category[1]" :value="id" v-if="discountVisible(id)">{{ getTitle('discounts', 'description', id) }}</md-option>
                  </md-select>
                </md-field>
                <div v-if="seatCategory == 'partner_checkout'">
                  <div>
                    <Autocomplete v-model="partnerID" :getValue="partnerTitle" :stateObject="'partners'" :returnField="'id'" :searchBy="'title'" :label="'Odaberi partnera'"/>
                  </div>
                  <md-datepicker v-model="expiry" md-immediately>
                    <label>Vrijedi do</label>
                  </md-datepicker>
                </div>
                <md-field>
                  <label>Napomena</label>
                  <md-input v-model="note"/>
                </md-field>
                <md-field v-if="$store.state.theatre.pricelist_data.category.hasOwnProperty('0') && parseInt(getProsceniumAmount) > 0">
                  <label>Proscenij - {{ getProsceniumAmount }}/{{ $store.state.selectedObject.total_extra_seats }}</label>
                  <md-input v-model="proscenium"/>
                </md-field>
              </div>
              <p class="error-message">
                <span v-for="error in $store.state.errors">
                  {{ error }}<br>
                </span>
              </p>
              <p>Odabrano sjedala: <strong>{{ getSelectedSeats.length }}</strong></p>
              <p>Ukupna cijena: <strong>{{ formatCurrency(amount) }}</strong></p>
            </md-card-content>
            <md-card-actions v-if="getSelectedSeats.length > 0 || proscenium.toString().length > 0">
              <md-list-item v-if="$route.params.type === undefined || fromPage">
                <md-button :disabled="$store.state.clicked" class="md-raised md-primary md-dense" v-on:click="setTransaction()" v-if="isOccupied">
                  Zauzmi
                </md-button>
                <md-button :disabled="$store.state.clicked" class="md-raised md-primary md-dense" v-on:click="setTransaction('in_guests')" v-if="seatCategory == 'in_guests'">
                  Zauzmi
                </md-button>
                <md-button :disabled="$store.state.clicked" class="md-raised md-primary md-dense" v-on:click="setTransaction('offline_checkout', true);" v-if="['sale', 'employee'].includes(seatCategory) && showPayment">
                  Plati
                </md-button>
                <md-button :disabled="$store.state.clicked" class="md-raised md-primary md-dense" v-on:click="setTransaction('reservation');" v-if="['reservation', 'employee'].includes(seatCategory) && showPayment">
                  Rezerviraj
                </md-button>
                <md-button :disabled="$store.state.clicked" class="md-raised md-primary md-dense" v-on:click="setTransaction('offline_checkout');" v-if="seatCategory == 'gratis'">
                  Plati
                </md-button>
                <md-button :disabled="$store.state.clicked" class="md-raised md-primary md-dense" v-on:click="setTransaction();" v-if="seatCategory == 'partner_checkout'">
                  Izdaj ponudu
                </md-button>
              </md-list-item>
              <md-list-item v-else>
                <md-button class="md-raised md-primary md-dense" v-on:click="edit();">
                  Izmjeni
                </md-button>
              </md-list-item>
            </md-card-actions>
          </md-card>
        </div>
      </div>
    <TransactionDetails :fromPage="true" v-if="detailsVisible" @close="detailsVisible = false" class="details-page-inner md-scrollbar"/>
    </div>


    <md-dialog :md-active.sync="pay" :md-click-outside-to-close="false" :md-close-on-esc="false" class="dialog-container pay-dialog md-scrollbar">
      <md-dialog-title>Način plaćanja</md-dialog-title>
        <md-card-content>
          <div class="md-layout centered">
            <h4>Ukupna cijena: <strong>{{ formatCurrency(visibleAmount) }}</strong></h4>
            <md-radio v-model="paymentType" value="cash">Gotovina</md-radio>
            <md-radio v-model="paymentType" value="card">Kartica</md-radio>
            <md-radio v-model="paymentType" value="virman">Virman</md-radio>
            <md-radio v-model="paymentType" value="coupon">Darovni bon</md-radio>
            <md-checkbox v-model="r1">R1 račun</md-checkbox>
          </div>
          <div v-if="paymentType == 'card'" class="md-layout">
            <md-field>
              <label>Tip kartice</label>
              <md-select v-model="card_type">
                <md-option value="american">American</md-option>
                <md-option value="diners">Diners</md-option>
                <md-option value="maestro">Maestro</md-option>
                <md-option value="master">Master</md-option>
                <md-option value="visa">VISA</md-option>
                <md-option value="discovery">Discovery</md-option>
                <md-option value="v-pay">V Pay</md-option>
                <md-option value="union-pay">UnionPay</md-option>
              </md-select>
            </md-field>
            <md-field>
              <label>Broj rata</label>
              <md-select v-model="installments">
              <md-option value="1">1</md-option>
              <md-option value="2">2</md-option>
              <md-option value="3">3</md-option>
              <md-option value="4">4</md-option>
              <md-option value="5">5</md-option>
              <md-option value="6">6</md-option>
              </md-select>
            </md-field>
          </div>
          <div v-show="r1" class="md-layout">
            <md-field :class="messageClass('name', r1Data)">
              <label>Naziv poduzeća</label>
              <md-input type="text" required v-model="r1Data.name"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('address', r1Data)">
              <label>Adresa</label>
              <md-input type="text" required v-model="r1Data.address"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('city', r1Data)">
              <label>Grad</label>
              <md-input type="text" required v-model="r1Data.city"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('postal_code', r1Data)">
              <label>Poštanski broj</label>
              <md-input type="text" required v-model="r1Data.postal_code"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
            <md-field :class="messageClass('oib', r1Data)">
              <label>OIB</label>
              <md-input type="text" required v-model="r1Data.oib"/>
              <span class="md-error">Ovo polje je obavezno</span>
            </md-field>
          </div>
          <md-dialog-actions>
            <md-button class="md-accent md-dense md-raised" v-on:click="pay = false; cancelTransaction()">
              Odustani
            </md-button>
            <md-button class="md-primary md-dense md-raised" v-on:click="setPaymentType($store.state.selectedObject.id)">
              Naplati
            </md-button>
          </md-dialog-actions>
        </md-card-content>
      </md-dialog>

      <md-dialog v-if="$store.state.dialogs.transactionDetails" :md-active.sync="$store.state.dialogs.transactionDetails" class="seat-details md-scrollbar">
        <md-toolbar md-elevation="0">
          <md-button class="md-icon-button md-accent md-raised" v-on:click="$store.state.dialogs.transactionDetails = false">
            <md-icon>close</md-icon>
          </md-button>
          <h3 class="md-title">Detalji sjedala</h3>
        </md-toolbar>
        <div>
          <md-table>
          <md-table-row>
            <md-table-head>ID</md-table-head>
            <md-table-head>Kupac</md-table-head>
            <md-table-head>Napomena</md-table-head>
            <md-table-head>Status</md-table-head>
            <md-table-head>Cijena</md-table-head>
            <md-table-head>Akcije</md-table-head>
          </md-table-row>
          <md-table-row md-selectable="single" md-auto-select>
            <md-table-cell md-numeric>{{ $store.state.currentTransaction.id }}</md-table-cell>
            <md-table-cell>
              <span v-if="$store.state.currentTransaction.data.hasOwnProperty('employee')">{{ $store.state.currentTransaction.data.employee.first_name }} {{ $store.state.currentTransaction.data.employee.last_name }}</span>
              <span v-else-if="$store.state.currentTransaction.data.hasOwnProperty('buyer')">{{ getHolder($store.state.currentTransaction.data.buyer) }}</span>
              <span v-else-if="$store.state.currentTransaction.data.hasOwnProperty('partner')">{{ $store.state.currentTransaction.data.partner.title }}</span>
            </md-table-cell>
            <md-table-cell>{{ $store.state.currentTransaction.data.note }}</md-table-cell>
            <md-table-cell>{{ getStatus($store.state.currentTransaction.status, $store.state.currentTransaction.data.is_cancelled) }}</md-table-cell>
            <md-table-cell class="capitalize">{{ getPaymentType($store.state.currentTransaction.payment_type) }}<span v-if="$store.state.currentTransaction.payment_type == 'card'">/{{ $store.state.currentTransaction.card_type }}</span></md-table-cell>
            <md-table-cell>{{ formatCurrency($store.state.currentTransaction.amount) }}</md-table-cell>
            <md-table-cell>
              <md-button class="md-raised md-dense md-primary" v-on:click="$store.state.dialogs.transactionDetails = false; detailsVisible = true; body.style.overflow = 'hidden'">
                Detalji
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
        </div>
        <div class="seat-list">
          <h3>Sjedala u transakciji</h3>
          <div>
            <p v-for="value, seat in $store.state.currentTransaction.data.seats">
              {{ getSeatInfo(seat).title }} {{ getSeatInfo(seat).orientation }}<br>
              <b>Sjedalo</b> {{ getSeatInfo(seat).seatID }}, <b>red/loža</b> {{ getSeatInfo(seat).rowID }}
            </p>
          </div>
        </div>
      </md-dialog>

      <md-dialog-confirm :md-active.sync="gratis"
                md-title="Gratis"
                md-content="Jeste li sigurni?"
                md-confirm-text="Da"
                md-cancel-text="Odustani"
                v-on:md-confirm="setGratis()"
                v-on:md-cancel="cancelTransaction()"
                >
      </md-dialog-confirm>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import SubscriberValidation from '../../mixins/subscriber-validator.js';
import FormatCurrency from '../../mixins/format-currency';
import PaymentType from '../../mixins/payment-type';


export default {
  name: 'TicketTheatre',
  mixins: [FormatCurrency, PaymentType('fromTheatre')],
  props: ['fromPage'],
  data(){
    return {
      seatAction: null,
      selectedPersonIndex: null,
      discount: false,
      selectedSeats: [],
      hasDiscount: false,
      seatCategory: 'sale',
      partnerID: '',
      employeeID: '',
      amount: 0,
      detailsVisible: false,
      body: null,
      partnerTitle: '',
      getAmount: true,
      gratis: false,
      pricelistID: '',
      showEmployee: true,
      showGratis: true,
      defaultDiscount: 0,
      expiry: '',
      note: '',
      seatDetails: false,
      proscenium: '',
      pay: false,
      visibleAmount: 0,
      occupiedStatus: ['theatre_manager', 'sponsor', 'lease', 'system_reserve', 'used_in_performance'],
      screen: null,
      screens: [],
    }
  },

  mounted(){
    this.body = window.document.body;
    this.loaded();
  },

  computed:{
		...mapGetters([
      'getSelectedSeats',
      'getFullPrice',
      'isPageLoaded',
      'getStatus',
      'getHolder'
    ]),

    getProsceniumAmount(){
      return this.$store.state.selectedObject.total_extra_seats - (this.$store.state.selectedObject.sold_extra_seats + this.$store.state.selectedObject.reserved_extra_seats)
    },

    showPayment(){
      return this.pricelistID.toString().length > 0 && this.pricelistID !== null;
    },

    isOccupied(){
      return this.occupiedStatus.includes(this.seatCategory);
    },

    employeeDiscount(){
      return this.$store.state.receivedData.discounts.list.filter((discount) =>{return discount.kind == 'employee'})[0].id;
    },

    gratisDiscount(){
      return this.$store.state.receivedData.discounts.list.filter((discount) =>{return discount.kind == 'gratis'})[0].id;
    },
  },

  methods:{
    getTitle(stateObject, key, id){
      let object = this.$store.state.receivedData[stateObject].list.filter((object) =>{return object.id == id})[0];
      return object !== undefined ? object[key] : '';
    },

    backClicked(){
      this.fromPage ? this.$emit('close', false) : this.$store.dispatch('setActiveTab', this.$store.state.previousTab.tab)
    },

    getPaymentType(paymentType){
      if(paymentType == 'cash') return 'Gotovina';
      else return ''
    },

    getSeatInfo(seat){
      let data = seat.split('-');
      let rowID = data[2];
      let rowCategory = `${data[0]}-${data[1]}`;
      return {
        orientation: seat.includes('-l-') ? 'Lijevo' : 'Desno',
        title: this.$store.state.rowIDs[rowCategory].title,
        position: this.$store.state.rowIDs[rowCategory].position,
        seatID: data[3],
        rowID: rowID,
      }
    },

    discountVisible(id){
      let discount = this.$store.state.receivedData.discounts.list.filter((discount) => {return discount.id == id})[0];
      if(discount && discount.hasOwnProperty('kind')){
        return !['employee'].includes(discount.kind)
      }
      return false
    },

    async setPrice(defaultDiscount=false){
      let categoryID = null;
      let discountID = null;
      if(defaultDiscount) discountID = this.defaultDiscount;
      else discountID = this.pricelistID;
      for(categoryID in this.$store.state.selectedObject.pricelist_data.category){
        this.$store.state.categories[categoryID].price = this.$store.state.selectedObject.pricelist_data.category[categoryID][discountID];
      }
    },

    async edit(){
      this.$store.state.isTheatre = true;
      let status = this.$store.state.currentTransaction.status;
      await this.setTransaction(status, false, true);
    },

    setGratis(){
      let context = {
        'status': 'offline_sold',
        'showTransaction': true,
        'getTheatre': true,
      };
      this.$store.dispatch('updateTransaction', {context});
    },

    async setTransaction(type='', dialog=false, edit=false){
      this.selectedSeats = this.$store.getters.getSelectedSeats;
      this.seatAction = type == '' ? this.seatCategory : type;
      this.visibleAmount = parseFloat(this.amount).toFixed(2);
      let context = {
        'performance': this.$store.state.selectedObject.id,
        'kind': 'performance',
        'start_time': this.$store.state.selectedObject.start_time,
        'seat_updates':{
          'status': this.seatAction,
          'seats': this.$store.getters.getSeatWithRow,
        },
        'status': this.seatAction,
        'amount': parseFloat(this.amount).toFixed(2),
        'getTheatre': true,
        'price_label': this.pricelistID,
        'isTicket': true,
        'isFromPage': this.fromPage,
        'note': this.note,
      }

      if(this.proscenium.toString().length > 0){
        context.seat_updates['extra_seats'] = parseInt(this.proscenium);
      }

      if(['sale', 'empolyees'].includes(this.seatCategory)){
        context['status'] = 'offline_checkout'
      }

      if(this.seatCategory == 'used_in_performance'){
        context['status'] = 'used_in_performance'
      }

      if(this.seatCategory == 'reservation' || this.seatCategory == 'employee'){
        context['showTransaction'] = true;
      }

      if(this.seatCategory == 'employee'){
        let employee = this.$store.state.receivedData.employees.list.filter((employee) =>{return employee.id == this.employeeID})
        context['employee'] = {
          'id': this.employeeID,
          'last_name': employee.last_name,
          'first_name': employee.first_name,
        };
      }

      if(['sponsor', 'lease'].includes(this.seatCategory)){
        context['partner'] = this.partnerID;
      }

      if(this.seatCategory == 'partner_checkout'){
        context['showTransaction'] = true;
        context['expiry_date'] = this.expiry;
        context['partner'] = this.partnerID;
        context['payment_type'] = 'virman';
      }

      if(this.seatCategory == 'gratis'){
        this.gratis = true;
        context['getTheatre'] = false;
      }

      this.getAmount = false;
      if(!edit) await this.$store.dispatch('createTransaction', {context});
      else{
        context['abort_transaction'] = this.$store.state.currentTransaction.id;
        await this.$store.dispatch('editTransaction', {context});
      }
      if(dialog && this.$store.state.errors.length == 0) this.pay = true;
    },

    async cancelTransaction(){
      await this.$store.dispatch('cancelTransaction', {status: 'aborted'});
      this.$store.dispatch('getTheatre', {url: `${this.$store.state.urls.performances}${this.$store.state.selectedObject.id}/`})
    },

    async changeAmount(){
      await this.setPrice();
      let amount = this.getSelectedSeats.length == 0 ? 0 : parseFloat(this.getFullPrice(this.discount));
      this.amount = amount;
      if(this.proscenium.toString().length > 0){
        this.amount = amount + parseFloat(parseInt(this.proscenium)*this.$store.state.selectedObject.pricelist_data.category[0][this.pricelistID])
      }
    },

    sendScreen(){
      let context = {
        screen: this.screen,
        performance: this.$store.state.selectedObject.id,
      }
      this.$store.dispatch('sendScreen', {context});
    },

    async loaded(){
      this.$store.state.isTicket = true;
      if(this.$route.params.type === undefined || this.fromPage){
        this.pricelistID = this.$store.state.receivedData.discounts.list.filter((discount) => {return discount.kind == 'regular'})[0].id;
        this.defaultDiscount = this.pricelistID;
        if(!this.$store.state.selectedObject.pricelist_data.category[1].hasOwnProperty(this.employeeDiscount)) this.showEmployee = false;
        if(!this.$store.state.selectedObject.pricelist_data.category[1].hasOwnProperty(this.gratisDiscount)) this.showGratis = false;

      } else if(this.$route.params.type == 'uredi'){
        this.$store.state.selectedSeats = [];
        if(this.$store.state.currentTransaction.data.hasOwnProperty('extra_seats')) this.proscenium = Object.keys(this.$store.state.currentTransaction.data.extra_seats).length;

        this.pricelistID = this.$store.state.currentTransaction.data.pricelist_id;
        this.note = this.$store.state.currentTransaction.data.note;

        if(this.$store.state.currentTransaction.status == 'partner_checkout'){
          this.partnerID = this.$store.state.currentTransaction.data.partner.id;
          this.pricelistID = this.$store.state.currentTransaction.data.pricelist_id;
          this.r1Data.name = this.$store.state.currentTransaction.data.partner.title;
          this.r1Data.postal_code = this.$store.state.currentTransaction.data.partner.postal_code;
          this.r1Data.oib = this.$store.state.currentTransaction.data.partner.oib;
          this.r1Data.city = this.$store.state.currentTransaction.data.partner.city;
          this.r1Data.address = this.$store.state.currentTransaction.data.partner.address;
          this.expiry = this.$store.state.currentTransaction.expiry_date;
        }

        else if(this.$store.state.currentTransaction.data.hasOwnProperty('employee')){
          this.employeeID = this.$store.state.currentTransaction.data.employee.id;
          this.pricelistID = this.$store.state.currentTransaction.data.pricelist_id;
        }

        else if(this.$store.state.currentTransaction.status == 'sposnor'){
          this.partnerID = this.$store.state.currentTransaction.data.sposnor;
        }

        else if(this.$store.state.currentTransaction.status == 'lease'){
          this.partnerID = this.$store.state.currentTransaction.data.lease;
        }

        let key = null;
        for(key in this.$store.state.currentTransaction.data.seats){
          let data = key.split('-');
          let seat = '';
          let row = '';
          seat = data[data.length-1];
          data.forEach((item, index) =>{
            if(index < data.length - 2) row+=(item+'-')
            else if(index < data.length - 1) row+=item
          });
          this.$store.state.selectedSeats.push({
            rowID: row,
            seatID: seat,
          })
          this.$store.state.theatre.rows[row].seats[seat].status = 'selected';
        }
        this.pricelistID = this.$store.state.currentTransaction.data.price_label_id;
        await this.setPrice();
        this.seatCategory = this.$store.state.currentTransaction.status;

        if(this.$store.state.currentTransaction.status == 'partner_checkout'){
          this.partnerTitle = this.$store.state.currentTransaction.data.partner.title;
        }
      }
      await this.$store.dispatch('getShowScreens');
      this.screens = this.$store.state.receivedData.showScreens;
    }
  },

  watch: {
    getSelectedSeats(newValue, oldValue){
      let hasDiscount = false;
      for(let i = 0; i < newValue.length; i++){
        if(newValue[i].discount != newValue[i].price){
          hasDiscount = true;
          break;
        }
      }
      this.changeAmount();
      this.hasDiscount = hasDiscount;
    },

    seatCategory(value){
      if(this.$route.params.type === undefined || this.fromPage){

        if(value == 'employee'){
          this.pricelistID = this.employeeDiscount;
        } else if(['gratis', 'theatre_manager', 'used_in_performance'].includes(value)){
          this.pricelistID = this.gratisDiscount;
        } else{
          this.pricelistID = this.defaultDiscount;
        }

        if(this.defaultDiscount != this.pricelistID && !['sale', 'employee'].includes(this.seatCategory)){
          this.setPrice(true);
        } else if(this.seatCategory == 'sale') this.setPrice();

        this.note = '';
        this.changeAmount();
      }
    },

    async pricelistID(){
      this.changeAmount();
    },

    proscenium(value){
      this.changeAmount();
    },

    async isPageLoaded(value){
      if(value){
        this.loaded();
      }
    },

    //getSelectedSeats(){
    //  if(this.getAmount) this.changeAmount();
    //}
  }
}
</script>


<style scoped lang="scss">
.add-subscriber{
  margin: 0;
}

.selected-tickets{
  .half-height{
    max-height: calc(50vh - 100px) !important;
  }
}

.seat-details{
  max-width: 1200px;
  width: 100%;
  overflow-y: scroll;
  z-index: 3213212123;
  .seat-list{
    padding: 50px 0 50px 24px;
    div{
      display: flex;
      flex-wrap: wrap;
    }
    h3{
      margin-bottom: 0;
    }
    p{
      margin: 35px 45px 0 0;
    }
  }
  .md-title{
    color: #000;
  }
}

.theatre-title{
  position: absolute;
  margin: 0;
  right: 50px;
}

.theatre-play-title{
  top: 5px;
  right: auto;
  left: 20px;
  font-size: 18px;
  width: calc(100% - 350px);
  text-align: center;
  span{
    font-size: 16px;
  }

  & + .theatre-container{
    margin-top: 40px;
  }
}

.theatre-container{
  .back-button{
    top: -5px;
    left: -20px;
  }
}

.pay-dialog{
  z-index: 100000;
}

.half-height{
  max-height: calc(50vh - 50px);
  overflow-y: scroll;
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/TicketTheatre.vue